import { useQuery, keepPreviousData, type UseQueryOptions } from '@tanstack/react-query';
import type { PageResponse } from '@models/api';
import { getProductSalesRank, type GetSalesRankProductResponse } from '@apis/summary';
import { getDashboardKpiRangeKst } from '@utils/time';

/**
 * Presets used across dashboard KPIs and ranking panels.
 * - TODAY: current day in KST
 * - R7 / R30: rolling window excluding today (recommended for stable KPI comparisons)
 */
export type DashboardKpiPreset = 'TODAY' | 'R7' | 'R30';

export const useSummarySalesByProduct = (preset: DashboardKpiPreset) => {
  const queryOptions: UseQueryOptions<PageResponse<GetSalesRankProductResponse>, Error> = {
    queryKey: ['dashboardSummarySalesByProduct', preset],
    queryFn: () => {
      const range = getDashboardKpiRangeKst(preset);
      return getProductSalesRank(range);
    },
    placeholderData: keepPreviousData,
    staleTime: 60_000,
    refetchOnWindowFocus: false,
  };

  return useQuery(queryOptions);
};
